import React, { useState } from "react";

const Tooltip = (props: any) => {
    let timeout: any;
    const [active, setActive] = useState(false);

    const showTip = () => {
        timeout = setTimeout(() => {
            setActive(true);
        }, props.delay || 200);
    };

    const hideTip = () => {
        clearInterval(timeout);
        setActive(false);
    };

    return (
        <React.Fragment>
            {
                props.content && (
                    <div
                        className="d-flex Tooltip-Wrapper"
                        // When to show the tooltip
                        onMouseEnter={showTip}
                        onMouseLeave={hideTip}
                    >
                        {/* Wrapping */}
                        {props.children}
                        {active && (
                            <div className={`Tooltip-Tip ${props.direction || "top"}`}>
                                {/* Content */}
                                {props.content}
                            </div>
                        )}
                    </div>
                )
            }

            {
                !props.content && (
                    <React.Fragment>
                        {props.children}
                    </React.Fragment>
                )
            }
        </React.Fragment>
    );
};

export default Tooltip;
